import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'

const getBanners = (state: ReduxState) => state.banners

export const getTargetBannersSelector = createSelector(getBanners, (banners) => banners.targetBanners)

export const getBannersPriorityMoreFifty = createSelector(getTargetBannersSelector, (banners) =>
  banners.filter((banner) => banner.priority > 50),
)

export const getBannersPriorityLessFifty = createSelector(getTargetBannersSelector, (banners) =>
  banners.filter((banner) => banner.priority <= 50),
)
